<template>
  <div class="nums detec">
    <div class="num">
      <div class="u-flex u-row-between">
        <div class="temp u-flex">
          <img
            class="img"
            v-if="vol.alarmStatus === 1"
            :src="vol.iconNormalFullPath"
          />
          <img
            class="img"
            v-if="vol.alarmStatus === 2"
            :src="vol.iconAbnormalFullPath"
          />
          <img
            class="img"
            v-if="vol.alarmStatus === 0"
            :src="vol.iconAlarmFullPath"
          />

          <div style="margin-left: 3px">{{ vol.name }}</div>
        </div>

        <div
          v-if="
            isyuzhiutil(vol) && ['c0', 'c1', 'a0', 'a1'].includes(userRole) > -1
          "
        >
          <Tooltip
            v-nohasPermi="['m3', 'm4']"
            theme="light"
            word-wrap
            trigger="hover"
            content="报警配置"
          >
            <img
              @click="yuzhiShow(vol)"
              class="pot"
              src="@/assets/images/shezhifeis.png"
              width="14px"
              height="14px"
            />
          </Tooltip>
        </div>

        <!-- <Dropdown placement="bottom-end" style="padding:0">
         
          <DropdownMenu slot="list" style="    height: 43px">
            <a href='javascript:;' @click="yuzhiShow(vol)">
              <DropdownItem style="text-align: center; border:none">报警配置
              </DropdownItem>
            </a>
          </DropdownMenu>
        </Dropdown> -->
      </div>
      <div class="cur">
        <div style="display: flex">
          <strong
            class="cur-strong"
            :class="
              vol.alarmStatus === 1
                ? 'black'
                : vol.alarmStatus === 2
                ? 'warning'
                : 'error'
            "
          >
            <template v-if="curDetails.onLineStatus === 'OFFLINE'">-</template>
            <template v-else-if="vol.currentValue">{{
              methFixedName1(vol.currentValue, vol)
            }}</template>
            <template v-else>-</template>
          </strong>
          <!-- v-if="vol.unit" -->
          <template v-if="vol.currentValue">
            <template v-if="curDetails.onLineStatus != 'OFFLINE'">
              <small
                v-if="vol.unit"
                class="small"
                :class="
                  vol.alarmStatus === 1
                    ? 'black'
                    : vol.alarmStatus === 2
                    ? 'warning'
                    : 'error'
                "
                >&nbsp;{{ vol.unit }}&nbsp;</small
              >
            </template>
          </template>
          <!-- viscosity_plus -->
          <div
            v-if="
              vol.onLineStatus == 1 &&
              vol.currentValue === null &&
              vol.identifier == 'viscosity_plus'
            "
            style="position: relative; top: 16px; left: 6px; width: 200px"
          >
            <Tooltip
              :transfer="true"
              max-width="200"
              theme="light"
              word-wrap
              trigger="hover"
              :content="vol.currentLog"
            >
              <img
                style="width: 12px; height: 12px"
                src="@/assets/images/warning.png"
              />
            </Tooltip>
          </div>
          <template>
            <div class="rhdtai-invalid" v-if="vol.valid == 0">无效值</div>
          </template>
        </div>
      </div>
      <div class="tempNum">
        <p
          class="history u-text-left"
          v-if="vol.oilSiteFluctuate && vol.oilSiteFluctuate.value"
        >
          <small>
            {{ formatestart(vol.oilSiteFluctuate.timeEnd) }} 较
            {{ formatestart(vol.oilSiteFluctuate.timeStart) }}
            {{ vol.oilSiteFluctuate.isUp == 1 ? "上升" : "下降" }}
            {{
              (vol.oilSiteFluctuate.isUp == 1
                ? vol.oilSiteFluctuate.value
                : vol.oilSiteFluctuate.value < 0
                ? -vol.oilSiteFluctuate.value
                : vol.oilSiteFluctuate.value) | fixedName1
            }}
          </small>
        </p>
        <p style="height: 21px" v-else></p>
        <div class="u-flex u-col-top mw">
          <div class="zb-left mw">
            <div class="history u-text-left">
              <div
                class="font10 left4"
                :style="{ color: vol.oilSiteThreshold.topTopLineColor }"
              >
                <span class="">
                  告警(高):{{ vol.oilSiteThreshold.topTopLine | fixedName1 }}
                </span>
              </div>
            </div>
            <div class="history u-text-left">
              <div
                class="font10 left4"
                :style="{ color: vol.oilSiteThreshold.topLineColor }"
              >
                <span v-if="vol.oilSiteThreshold.topLine">
                  注意(高):{{ vol.oilSiteThreshold.topLine | fixedName1 }}
                </span>
                <span v-else> 注意(高):- </span>
              </div>
            </div>
            <div class="history u-text-left">
              <div
                class="font10 left4"
                :style="{ color: vol.oilSiteThreshold.bottomLineColor }"
              >
                <span v-if="vol.oilSiteThreshold.bottomLine">
                  注意(低):{{ vol.oilSiteThreshold.bottomLine | fixedName1 }}
                </span>
                <span v-else> 注意(低):- </span>
              </div>
            </div>
            <div class="history u-text-left">
              <div
                class="font10 left4"
                :style="{ color: vol.oilSiteThreshold.bottomBottomLineColor }"
              >
                <span class="">
                  告警 (低):{{
                    vol.oilSiteThreshold.bottomBottomLine | fixedName1
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="zb-right">
          <p class="zb-rig-item">数据更新：{{ vol.gmtModified || "无" }}</p>
          <p class="zb-rig-item" style="margin-top: 4px">
            最新报警：{{ vol.alarmTime || "无" }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import zbiaowu from "./detac-zbiao.vue";
import toRoleName from "@/mixins/roleName";

import ls from "store2";
export default {
  name: "dection",
  components: {
    zbiaowu,
  },
  mixins: [toRoleName],
  props: ["vol", "curDetails", "index", "userInfo"],
  data() {
    return {
      userRole: null,
    };
  },
  filters: {
    fixedName: (num) => {
      let formateNum = 0;
      let numb1 = Number(num);
      if (numb1) {
        formateNum = Number(num).toFixed(2);
        return Number(formateNum);
      } else {
        return num;
      }
    },
    fixedName1: (value) => {
      if (Number(value) == 0) {
        if (value === "0" || value === 0) {
          return value;
        } else {
          return "-";
        }
      }
      value = Number(value).toFixed(2);
      let jisuan = value.toString().split(".");
      let find = 2;
      if (jisuan[1]) {
        if (Number(jisuan[1]) == 0) {
          find = 0;
        } else {
          let strarr = jisuan[1].split("");
          if (strarr[1] == 0) {
            find = 1;
          }
        }
      }
      return Number(value).toFixed(find);
    },
  },
  computed: {
    formatestart() {
      return (timeStart) => {
        let data = moment(Number(timeStart)).format("yyyy-MM-DD HH:mm");
        return data;
      };
    },
    givalarmFormart() {
      return (vol, index) => {
        const { name, alarmStatus } = vol;
        if (alarmStatus == 1) {
          //普通状态 不用管
          return [];
        }
        let str = [];
        let currentValue = Number(vol.currentValue);
        let topLine = Number(vol.oilSiteThreshold.topLine);
        let topTopLine = Number(vol.oilSiteThreshold.topTopLine);
        let bottomLine = Number(vol.oilSiteThreshold.bottomLine);
        let bottomBottomLine = Number(vol.oilSiteThreshold.bottomBottomLine);
        let maxNum = 0;
        let minNum = 0;
        if (index == 0) {
          if (topTopLine <= currentValue) {
            str = ["error"];
          }
        } else if (index == 1) {
          if (bottomLine) {
            maxNum = bottomLine;
          } else if (topLine) {
            maxNum = topLine;
          } else if (topTopLine) {
            maxNum = topTopLine;
          } else {
            maxNum = -1;
          }

          if (maxNum == -1) {
            if (bottomBottomLine >= currentValue) {
              str = ["error"];
            }
          } else {
            if (bottomBottomLine >= currentValue) {
              str = ["error"];
            }
          }
        } else if (index == 2) {
          if (vol.oilSiteThreshold.isAlgorithmTop == 1) {
            topLine = Number(vol.oilSiteThreshold.upThreshold);
          }
          if (vol.oilSiteThreshold.isAlgorithmBottom == 1) {
            bottomLine = Number(vol.oilSiteThreshold.downThreshold);
          }
          if (topTopLine) {
            maxNum = topTopLine;
          } else {
            maxNum = -1;
          }
          if (maxNum == -1) {
            if (topLine <= currentValue) {
              str = ["warning"];
            }
          } else {
            if (topLine <= currentValue && maxNum > currentValue) {
              str = ["warning"];
            }
          }
        } else if (index == 3) {
          if (vol.oilSiteThreshold.isAlgorithmBottom == 1) {
            bottomLine = Number(vol.oilSiteThreshold.downThreshold);
          }
          if (topLine) {
            maxNum = topLine;
          } else if (topTopLine) {
            maxNum = topTopLine;
          } else {
            maxNum = -1;
          }

          if (maxNum == -1) {
            if (
              (!bottomBottomLine || bottomBottomLine < currentValue) &&
              bottomLine >= currentValue
            ) {
              str = ["warning"];
            }
            if (bottomLine <= currentValue) {
              str = ["warning"];
            }
          } else {
            if (vol.name == "油温") {
            }
            if (
              (!bottomBottomLine || bottomBottomLine < currentValue) &&
              bottomLine >= currentValue
            ) {
              str = ["warning"];
            } else if (bottomLine <= currentValue && maxNum >= currentValue) {
              str = ["warning"];
            }
          }
        }

        return str;
      };
    },
  },
  mounted() {
    this.userRole = this.userInfo.authority;

    const role = this.toRoleName(this.userRole);
    if (this.userRole) ls.set("userRole", role);
  },
  methods: {
    methFixedName1: (num, obj) => {
      let formateNum = 0;

      if (!obj["teshu"]) {
        formateNum = Number(num).toFixed(2);
        return Number(formateNum);
      } else {
        return num;
      }
    },
    ongetinto(index, vist) {},
    isyuzhiutil(vol) {
      const { oilSiteIdentifierIcon } = vol;
      if (
        oilSiteIdentifierIcon.secureLine == "上限" ||
        oilSiteIdentifierIcon.secureLine == "上下限" ||
        oilSiteIdentifierIcon.secureLine == "下限"
      ) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 显示阈值
     * @param {Object} vol - 指标对象
     */
    yuzhiShow(vol) {
      let show = this.isyuzhiutil(vol);

      if (!show) {
        this.$Message.info("该指标没有报警配置项");
        return;
      }
      //vol.oilSiteIdentifierIcon.isShow
      if (!!vol.oilSiteIdentifierIcon.isShow) {
        this.$emit("mode", vol);
      } else {
        this.$Message.info("该指标已对客户隐藏，不可配置报警");
      }
      return;
    },
  },
};
</script>

<style lang="less" scoped>
.nums {
  display: flex;

  .num {
    flex: 0 0 100%;
    position: relative;

    .temp {
      font-size: 16px;
      // color: #0C479D;
      font-weight: 549;
      color: rgba(0, 0, 0, 0.851);

      .pw {
        font-size: 12px;
        color: #888;
      }

      .img {
        width: 24px;
        height: 24px;
      }

      .iconInfo {
        font-size: 15px;
        color: #bbb;
        cursor: pointer;
      }
    }

    .small {
      position: relative;
      top: 3px;
      left: -4px;
      font-size: 28px;
    }

    .cur {
      position: relative;
      font-size: 12px;
      color: #333;
      padding-top: 4px;
      display: flex;
      justify-content: space-between;
      align-items: self-end;
      position: relative;

      .cur-strong {
        font-size: 38px;
        font-weight: normal;
        line-height: 40px;
      }

      & > strong {
        font-size: 38px;
        font-weight: normal;
        line-height: 40px;
      }

      .btns {
        top: 6px;
        right: 0;
        text-align: right;

        // margin-top: -18px;
        li {
          margin-bottom: 0 !important;
        }

        .ivu-btn {
          width: 60px;
          margin: 6px 0;
          margin-left: 10px;
          font-size: 12px;
          color: #3163ad;
          border: 1px solid #3163ad !important;

          &:hover {
            color: #fff;
            background-color: #3163ad;
          }
        }
      }
    }

    .tempNum {
      position: relative;
      margin-bottom: 10px;

      small {
        font-size: 12px;
      }
    }
  }
}

.zb-left {
  display: flex;
  line-height: 19px;

  height: 42px;
  align-items: center; // border: 1px solid red;
  justify-content: space-between;
}

.left4 {
  left: -4px;
}

.zb-right {
  font-size: 12px;

  font-weight: 400;
  color: #262626;

  white-space: nowrap;

  .zb-rig-item {
    width: 100%;
    height: 32px;
    background: rgba(246, 247, 249, 0.349);
    display: flex;
    align-items: center;
    border-left: 8px solid rgba(144, 150, 171, 0.2);
    padding-left: 6px;
    font-size: 14px;
    font-weight: 400;
    color: #9096ab;
  }
}

.block {
  color: #000000;
}

.history {
  flex: 0 0 24%;
  margin-right: 0%;

  white-space: nowrap !important;

  .max-font {
    font-size: 14px;
  }
}

.histmier {
  width: 48%;
  white-space: nowrap;
}

.font10 {
  font-size: 14px;
  // border:1px solid red
}
</style>

<style lang="less">
.detec {
  li {
    padding: 12px 16px;
  }
}

.rhdtai-invalid {
  // width: 54px;
  height: 20px;
  background: rgba(44, 44, 44, 0.051);
  border-radius: 60px;
  font-size: 12px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #4d4d4d;

  padding: 2px 9px;
  position: relative;
  top: 16px;
}
</style>